module.exports = __webpack_public_path__ + "static/media/relax.8430ad94.jpeg";